import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, NavController, NavParams } from '@ionic/angular';

import { AbstractPage } from '../AbstractPage';
import { Rilevazione } from '../models/rilevazione-presenze/rilevazione';

import { TranslateService } from '@ngx-translate/core';
import { Subscription, timer } from 'rxjs';
import * as ProgressBar from '../../../node_modules/progressbar.js/dist/progressbar.min.js';
import { ChiaveConfig } from '../models/configurazioni/ChiaveConfig';
import { Presenza } from '../models/rilevazione-presenze/presenza';
import { RichiestaDiConferma } from '../models/rilevazione-presenze/richiesta-conferma';
import { ConfermaPresenzaService } from '../services/conferma-presenza-service';
import { ConfigService } from '../services/config-service/config-service';
import { EventsService } from '../services/eventsService';
import { RilevazionePresenzeService } from '../services/rilevazione-presenze-service';
import { UtilityService } from '../services/utility.service';
import { UserService } from '../services/user-service';

@Component({
    selector: 'app-verifica-presenza',
    templateUrl: './verifica-presenza.page.html',
    styleUrls: ['./verifica-presenza.page.scss'],
    standalone: false
})
export class VerificaPresenzaPage extends AbstractPage implements OnInit {
  running = false;
  complete = false;
  ended = false;
  durataVerificaPresenza: number;
  circle: any;
  circleConferme: any;
  rilevazione: Rilevazione;
  confermati = 0;
  lastConfermati = 0;
  presenti = 0;
  countSubscription: Subscription;
  presenze: Array<Presenza>;
  _presenze: Array<Presenza>;
  labelConfermati: string;
  lastCheck = false;
  impedisciVerifica = false;

  private subscription: Subscription;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public router: Router,
    public route: ActivatedRoute,
    private modalCtrl: ModalController,
    private configService: ConfigService,
    private confermaPresenzaService: ConfermaPresenzaService,
    private rilevazionePresenzeService: RilevazionePresenzeService,
    private translateService: TranslateService,
    public utilityService: UtilityService,
    public userService: UserService,
    public events: EventsService
  ) {
    super(navCtrl, router);
    this.presenze = [];
  }

  ngOnInit() {
    console.log('ngOnInit VerificaPresenzaPage');
    this.rilevazione = this.navParams.get('rilevazione');
    if (this.userService.isPTA()) {
      this.durataVerificaPresenza = 0;
      this.avvia(true);
      return;
    }
    this.durataVerificaPresenza = this.configService.getConfigurazione(
      ChiaveConfig.SECONDI_VERIFICA_PRESENZE
    );
    // console.log(`rilevazione in modal: ${JSON.stringify( this.rilevazione ) }`);
    this.labelConfermati = this.translateService.instant('verifica-presenza.confermati');
    this.rilevazionePresenzeService.countPresenzeNonSegnalate(this.rilevazione).subscribe(
      n => { this.presenti = n; });
    console.log('count presenti: ' + this.presenti);
    // this.seconds = this.durataVerificaPresenza;
    // console.log((Number(this.durataVerificaPresenza)+1)* 1000);
    const self = this;
    // https://progressbarjs.readthedocs.io/en/latest/#get-started
    this.circle = new ProgressBar.Circle('#progress', {
      color: '#FCB03C',
      duration: (Number(this.durataVerificaPresenza) + 1) * 1000,
      easing: 'linear',
      strokeWidth: 10,
      trailWidth: 6,
      text: { value: this.durataVerificaPresenza },
      step: function(state, circle) {
        self.timerTick(state, circle);
      }
    });
    this.circle.text.style.fontSize = '3.5rem';

    this.circleConferme = new ProgressBar.Circle('#progressConfermati', {
      color: '#FCB03C',
      easing: 'linear',
      strokeWidth: 10,
      trailWidth: 6,
      text: { value: this.getTextConfermati(this.confermati) }
    });
    this.circleConferme.text.style.fontSize = '3.5rem';
    this.circleConferme.text.style.textAlign = 'center';

    this.checkVerificaDisabled();

  }

  checkVerificaDisabled() {
    this.subscription = this.events.verificaDisattivata.subscribe(() => {
      this.impedisciVerifica = true;
    });
  }

  async timerTick(state: any, circle: any) {
    // console.log(circle.value());
    if (!this.running) {
      if (this.ended) {
        circle.set(circle.value());
      }
     return;
    }
    let value = Math.round(circle.value() * this.durataVerificaPresenza);
    value = this.durataVerificaPresenza - value;
    circle.setText(value);
    if (circle.value() === 1 && !this.lastCheck) {
      this.lastCheck = true;
      await this.countConfermati().then(() => {
        timer(1000).subscribe(() => {
          this.stopRunning(false, true, false);
        });
      });
    }
  }

  updateCircle(circle: any) {
    if (!this.running) {
      return;
    }

    // valorizza il circle con il numero di confermati, recuperato ogni tot (5?) secondi
    // tramite un timer avviato dalla richiesta di conferma
    // console.log('this.lastConfermati', this.lastConfermati);
    // console.log('this.confermati', this.confermati);
    if ( this.lastConfermati !== this.confermati ) {
        this.lastConfermati = this.confermati;
        circle.setText(this.getTextConfermati(this.confermati));
        circle.set(this.confermati / this.presenti);
    } else {
        return;
    }
    // se dovessero aver confermato tutti, lo segnala
    if (this.confermati === this.presenti) {
      this.stopRunning(false, true, true);
    }
  }

  stopRunning(_running: boolean, _ended: boolean, _complete: boolean) {
    this.running = _running;
    this.ended = _ended;
    this.complete = _complete;
    if (this.countSubscription) {
      this.countSubscription.unsubscribe();
      this.countSubscription = null;
    }
  }

  getTextConfermati(nConfermati: number) {
    const txt = '<span style="text-align: center;margin: 0px">' + nConfermati + '</span>' +
    '<p style="font-size: 1rem;margin-top: 0px;margin-bottom: 0px">' + this.labelConfermati + '</p>';
    return txt;
  }

  avvia(useRilCloseTime = false) {
    if (!this.running) {
      this.running = true;
      this.confermaPresenzaService.creaRichiesta(this.rilevazione, useRilCloseTime).subscribe(
        (richiesta: RichiestaDiConferma) => {
          if (this.userService.isDocente()) {
            this.circle.animate(1);
            // valorizza il circle con il numero di confermati, recuperato ogni tot (5?) secondi
            // tramite un timer avviato dalla richiesta di conferma
            this.countSubscription = timer(0, 5000).subscribe(() => this.countConfermati());
          } else {
            this.stopRunning(false, true, true);
            this.conferma();
            this.rilevazione.richiestaConferma = richiesta;
          }
        },
        e => {
          console.log(e);
          this.running = false;
          this.utilityService.showError(e);
        }
      );
    }
  }

  async conferma() {
    await this.modalCtrl.dismiss('{data: ok} ', 'cancel');
  }
  async annulla() {
    await this.modalCtrl.dismiss(null, 'cancel');
  }

  ionViewWillLeave() {
    // annulla il conteggio dei confermati che rimarrebbe inutilmente attivo
    if ( this.countSubscription ) {
      this.countSubscription.unsubscribe();
      this.countSubscription = null;
      this.subscription.unsubscribe();
    }
  }

  async countConfermati() {
    console.log('countConfermati');
    if (!this.ended) {
      await this.rilevazionePresenzeService.getPresenze(this.rilevazione).subscribe(
        list => {
          this._presenze = list;
          this.presenze = this._presenze.filter(presenza => {
            return (
              presenza.confermata()
            );
          });
          this.confermati = this.presenze.length;
          this.updateCircle(this.circleConferme);
        },
        error => {
          throw error;
        }
      );
    }
  }
}
